<div>
    
    <label i18n="@@jraapASAF" class="textColour">Send To Vault</label>

</div>

<div style="margin-top: 25px;">
                <form novalidate [formGroup]="FormValid">
                    <div>
                    <div class="container">
                        <div class="row topRowMargins">
                            <div class="col-lg-3"></div>
                            <div class="col-lg-6">
                                <div style="display:flex">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@TMshoppingcomplexchooseimage">Choose Analysis File</mat-label>
                                        <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Choose Analysis File" formControlName="imageName" id="imageName" [(ngModel)]="sendtovault.fileName" readonly>
                                    </mat-form-field>
                                    <div class="file-field" style="width: 20%;">
                                        <a class="btn-floating  btn-sm m-0  float-right">
                                            <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                                            <input type="file" id="imageupload" name="imageupload" (change)="imagePhotofunction($event)" formControlName="imageupload">
                                        </a>
                                    </div>
                                </div>
                          
                                </div>
                                <div class="col-lg-3"></div>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-lg">

                            </div>
                            <div class="col-lg text-center">
                                <button i18n="@@TMRunButton" type="button" (click)="uploadtovault()" [style.background-color]="backgroundColorButton"
                                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">upload To Vault</button>
                              
                                <button i18n="@@TMRunButton" type="button" (click)="deleteimage()" [style.background-color]="backgroundColorButton"
                                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">Cancel</button>
                            </div>
                            <div class="col-lg">

                            </div>
                        </div>
                    </div>
                </form>
